import { FC, useMemo } from 'react';
import { Select, SelectProps } from '../../form_components';
import { useDesign } from '../../hooks';
import { ObjectClass, Option } from '../../types';
import { Case, convertCase } from '../../utilities';

export type ObjectDropdownProps = (
  Omit<SelectProps<string>, 'options'>
  & {
    /** Applied to the select control element. */
    className?: string;
    /** @see DesignObject._class to select. */
    type?: ObjectClass;
  }
);

/** Select a @see DesignObject from a @see Design. */
export const ObjectDropdown: FC<ObjectDropdownProps> = ({
  className,
  type,
  ...selectProps
}) => {
  const serialized = useDesign();
  const typeName = (!type) ? 'object' : convertCase(
    type.replace(/NodeModel$/, ''),
    Case.title
  ).toLocaleLowerCase();

  const options = useMemo((): Option<string>[] => {
    return serialized.components.objects.filter((object) => {
      return !type || object._class === type;
    }).map((object) => {
      return {
        label: object.name ?? '<Unnamed>',
        value: object.id
      };
    });
  }, [serialized.components.objects, type]);

  return (
    <Select
      classNames={className ? { control: () => className } : undefined}
      noOptionsMessage={() => `No ${typeName}s in the design.`}
      placeholder={`Select ${typeName} from design.`}
      {...selectProps}
      options={options}
    />
  );
};
